export const GET_SUBSCRIPTION_REQUEST = "GET_SUBSCRIPTION_REQUEST"
export const GET_SUBSCRIPTION_SUCCESS = "GET_SUBSCRIPTION_SUCCESS"
export const GET_SUBSCRIPTION_FAIL = "GET_SUBSCRIPTION_FAIL"

export const GET_SUBSCRIPTIONDATE_REQUEST = "GET_SUBSCRIPTIONDATE_REQUEST"
export const GET_SUBSCRIPTIONDATE_SUCCESS = "GET_SUBSCRIPTIONDATE_SUCCESS"
export const GET_SUBSCRIPTIONDATE_FAIL = "GET_SUBSCRIPTIONDATE_FAIL"

export const GET_SUBSCRIPTIONS_DISPLAY_REQUEST = "GET_SUBSCRIPTIONS_DISPLAY_REQUEST";
export const GET_SUBSCRIPTIONS_DISPLAY_SUCCESS = "GET_SUBSCRIPTIONS_DISPLAY_SUCCESS";
export const GET_SUBSCRIPTIONS_DISPLAY_FAIL = "GET_SUBSCRIPTIONS_DISPLAY_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS"